import ActionsForm from '@/shared/mixins/actionsForm'
// import aprTemplateRiskTypeRepository from '@/shared/http/repositories/business/aprTemplateRiskType'
import aprTemplateStageServiceRepository from '@/shared/http/repositories/business/aprTemplateStageServiceRepository'
import { toast, loading } from '@/shared/utils/UIHelper'

// import Tools from '@/components/tools/Tools'

export default {
  name: 'addServiceStageApr',
  mixins: [ActionsForm],
  components: {},
  data () {
    return {
      cancelaServico: false,
      formAddServiceStage: {
        etapa: null
      },
      dataEtapaServico: [],
      dataServico: null

    }
  },

  props: ['aprId', 'revisao', 'dataTemplateAPR'],
  // aprid=>templateid

  watch: {
  },

  mounted () {
  },
  methods: {
    cancel () {
      this.cancelaServico = !this.cancelaServico
      this.$emit('cancelaEtapa', this.cancelaServico)
    },
    onLoad () {
      loading.push()
      aprTemplateStageServiceRepository.GetEtapaServico(this.aprId, this.revisao, this.dataTemplateAPR)
        .then((Response) => {
          loading.pop()
          this.dataEtapaServico = Response.data.data
        }).catch(Error => {
          loading.pop()
          toast.error('Erro ao carregar as informações')
        })
    },
    SalvaEtapaServico () {
      if (this.formAddServiceStage.etapa != null && this.formAddServiceStage.etapa !== undefined) {
        let dataServico = {
          colorStatusAPR: 'rgb(128 128 128)',
          emMemoria: true,
          id: null,
          revisao: null,
          etapaServicoId: this.formAddServiceStage.etapa.id,
          etapaServico: this.formAddServiceStage.etapa.descricao,
          dataCriacaoEtapa: null,
          templateRiscosDto: []
        }
        this.$emit('NovaEtapaServico', dataServico)
      } else {
        toast.warning('Selecione uma etapa de serviço')
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/apr/templateApr/components/addServiceStage/addServiceStage.js